import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import NFFilter from '../components/FilterContainer';
import FilterForm from '../components/FilterForm';
import CheckboxControl from '../components/CheckboxControl';
import {
  CONNECTION_STATUS,
  CONNECTION_STATUS_LABELS,
} from '../../../constants/ConnectionStatus';

import { Container } from '../styles';

const label = Object.values(CONNECTION_STATUS);

const Status = ({ isOpen, onClick, onApply, status }) => {
  const [selectedItem, setSelectedItem] = useState(status);

  useEffect(() => {
    if (status?.length < 1) {
      setSelectedItem([]);
    }
  }, [status]);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  return (
    <NFFilter
      label="Status"
      isOpen={isOpen}
      onClick={onClick}
      value={selectedItem.map(item => {
        return CONNECTION_STATUS_LABELS[item];
      })}
    >
      <FilterForm
        label="Filtrar por status"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          {label.map((filter, id) => (
            <CheckboxControl
              key={id}
              value={filter}
              onChange={handleChange}
              defaultChecked={selectedItem.some(
                item => parseInt(item) === filter,
              )}
              label={CONNECTION_STATUS_LABELS[filter]}
            />
          ))}
        </Container>
      </FilterForm>
    </NFFilter>
  );
};

const mapStateToProps = state => ({
  status: state.tracking.filters.listStatus,
});

export default connect(mapStateToProps)(Status);
